'use client';

import { type ComponentType, type ReactNode, useState, useEffect } from 'react';
import config from 'shared/config';
const overrideAsProd = false;
const ChartDevtools = (): ReactNode => {
  const [Devtools, setDevtools] = useState<ComponentType | null>(null);
  useEffect(() => {
    if (config('APP_ENV') !== 'development' || overrideAsProd) return;
    void import('@recharts/devtools').then(m => {
      setDevtools(() => m.RechartsDevtools);
    });
  }, []);
  if (Devtools === null) return null;
  return <Devtools />;
};
export default ChartDevtools;